/**
 * The drive an attachment is picked from (CT-5528).
 *
 * Fetchers in the exact shape `@aimsos/ui`'s `DrivePickerModal` asks for, so the
 * picker needs no adapter: `drives` as `{ id, name }` (the id is the vault
 * UUID), and `{ folders, documents }` for a root or a folder.
 *
 * TODO(CT-5528 / backend): the real vault endpoints. Mock-driven until then.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

/** TODO(CT-5528 / backend): `POST /v0/profile/drives/list`. */
export const listDrives = async () => {
  const response = await request('/v0/profile/drives/list', {});
  const { body } = validateApiResponse(response, 'Failed to load the drives');
  return body?.items ?? [];
};

/** TODO(CT-5528 / backend): `POST /v0/profile/drives/root` with `{ vault_uuid }`. */
export const fetchDriveRoot = async (vaultUuid) => {
  const response = await request('/v0/profile/drives/root', { vault_uuid: vaultUuid });
  const { body } = validateApiResponse(response, 'Failed to open the drive');
  return { folders: body?.folders ?? [], documents: body?.documents ?? [] };
};

/** TODO(CT-5528 / backend): `POST /v0/profile/drives/folder` with `{ folder_uuid, vault_uuid }`. */
export const fetchFolderChildren = async ({ folderUuid, vaultUuid }) => {
  const response = await request('/v0/profile/drives/folder', {
    folder_uuid: folderUuid,
    vault_uuid: vaultUuid,
  });
  const { body } = validateApiResponse(response, 'Failed to open the folder');
  return { folders: body?.folders ?? [], documents: body?.documents ?? [] };
};
